<template>
    <div class="main">
        <c-panel title="R.A.C — REGISTRO DE ADAPTAÇÃO CURRICULAR" titleIcon="fas fa-universal-access">

            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="16" :md="16">
                    <el-input v-model="filtro.aluno_nome" placeholder="Pesquisar por nome do aluno..." @keyup.native.enter="loadingRacs(1)" clearable @clear="loadingRacs(1)"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                    <el-button type="primary" @click="novo">NOVO R.A.C</el-button>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">Cod</th>
                            <th>Aluno</th>
                            <th style="width: 110px;">Data</th>
                            <th class="hidden-mobile">Áreas de adaptação</th>
                            <th style="width: 230px;" class="u-text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ item.aluno ? item.aluno.nome : '—' }}</td>
                            <td>{{ formatData(item.data_aplicacao) }}</td>
                            <td class="hidden-mobile">{{ (item.dados && item.dados.areas && item.dados.areas.length) ? item.dados.areas.join(', ') : '—' }}</td>
                            <td class="u-text-center acao">
                                <el-button size="mini" type="warning" plain icon="el-icon-notebook-2" title="Histórico de eventos" @click="abrirEventos(item)">Eventos</el-button>
                                <el-button size="mini" type="info" plain icon="el-icon-edit" title="Editar" @click="editar(item)"></el-button>
                                <el-button size="mini" type="primary" plain icon="el-icon-printer" title="Imprimir" @click="imprimir(item)"></el-button>
                                <el-button size="mini" type="danger" plain icon="el-icon-delete" title="Excluir" @click="excluir(item)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="5" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum R.A.C encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- Modal do R.A.C -->
            <el-dialog :title="dados.id ? 'EDITAR R.A.C' : 'NOVO R.A.C'" :visible.sync="modalVisivel" width="70%" :close-on-click-modal="false" append-to-body>
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="16">
                            <el-form-item label="Aluno">
                                <el-select v-model="dados.aluno_id" filterable remote :remote-method="searchAluno" :loading="loadingAluno"
                                    placeholder="Digite o nome do aluno..." style="width: 100%;" :disabled="!!dados.id">
                                    <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Data da aplicação">
                                <el-date-picker v-model="dados.data_aplicacao" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="Áreas de adaptação">
                        <el-select v-model="dados.areas" multiple filterable allow-create default-first-option placeholder="Selecione ou digite as áreas" style="width: 100%;">
                            <el-option v-for="a in areasOptions" :key="a" :label="a" :value="a"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Justificativa">
                        <el-input type="textarea" :rows="3" v-model="dados.justificativa"></el-input>
                    </el-form-item>
                    <el-form-item label="Estratégias de adaptação">
                        <el-input type="textarea" :rows="3" v-model="dados.estrategias"></el-input>
                    </el-form-item>
                    <el-form-item label="Recursos / materiais">
                        <el-input type="textarea" :rows="3" v-model="dados.recursos"></el-input>
                    </el-form-item>
                    <el-form-item label="Profissionais responsáveis">
                        <el-select v-model="dados.profissionais_responsaveis" multiple filterable allow-create default-first-option placeholder="Digite os nomes dos profissionais" style="width: 100%;">
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Observações">
                        <el-input type="textarea" :rows="3" v-model="dados.observacoes"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalVisivel = false">Cancelar</el-button>
                    <el-button type="primary" :loading="salvando" @click="salvar">SALVAR</el-button>
                </span>
            </el-dialog>

            <!-- Modal de eventos (histórico 1:N) -->
            <el-dialog title="HISTÓRICO DE EVENTOS" :visible.sync="eventosModalVisivel" width="60%" :close-on-click-modal="false" append-to-body>
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Data">
                                <el-date-picker v-model="novoEvento.data" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="14">
                            <el-form-item label="Descrição do evento">
                                <el-input v-model="novoEvento.descricao" placeholder="Descreva o evento/ocorrido"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" style="padding-top: 24px;">
                            <el-button type="primary" :loading="salvandoEvento" :disabled="!novoEvento.descricao" @click="salvarEvento">ADICIONAR</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 110px;">Data</th>
                            <th>Descrição</th>
                            <th style="width: 150px;">Responsável</th>
                            <th style="width: 60px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="ev in eventos" :key="ev.id">
                            <td>{{ formatData(ev.data) }}</td>
                            <td>{{ ev.descricao }}</td>
                            <td>{{ ev.responsavel ? ev.responsavel.name : '—' }}</td>
                            <td class="u-text-center">
                                <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="excluirEvento(ev)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!eventos.length">
                            <td colspan="4" class="u-text-center" style="padding: 16px; color: #909399;">Nenhum evento registrado.</td>
                        </tr>
                    </tbody>
                </table>

                <span slot="footer">
                    <el-button @click="eventosModalVisivel = false">Fechar</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: { aluno_nome: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        alunos: [],
        loadingAluno: false,
        modalVisivel: false,
        salvando: false,
        dados: { id: '', aluno_id: '', data_aplicacao: '', areas: [], justificativa: '', estrategias: '', recursos: '', profissionais_responsaveis: [], observacoes: '' },
        dadosOriginal: {},
        areasOptions: [
            'Leitura', 'Escrita', 'Matemática', 'Comunicação/Linguagem',
            'Socioemocional', 'Motora', 'Atenção/Concentração', 'Autonomia/Vida diária', 'Comportamento'
        ],
        // Eventos (histórico 1:N)
        eventosModalVisivel: false,
        racSelecionadoId: null,
        eventos: [],
        novoEvento: { data: '', descricao: '' },
        salvandoEvento: false
    }),
    mounted () {
        this.loadingRacs(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        loadingRacs (page) {
            this.paginate.page = page || 1
            this.statusList = false
            this.items = []
            this.$axios.post(`${this.baseUrl()}/api/rac-aluno/getAllPaginate?page=${this.paginate.page}`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.items = r.data.data || []
                    this.paginate.qtdItens = r.data.total
                    this.paginate.from = r.data.from
                    this.paginate.to = r.data.to
                    this.statusList = true
                }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        getPagePagination (page) {
            this.paginate.page = page
            this.loadingRacs(page)
        },
        searchAluno (query) {
            if (!query || query.length < 3) { this.alunos = []; return }
            this.loadingAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunos = r.data || []; this.loadingAluno = false })
                .catch(() => { this.loadingAluno = false })
        },
        novo () {
            this.dados = { id: '', aluno_id: '', data_aplicacao: this.$moment().format('YYYY-MM-DD'), areas: [], justificativa: '', estrategias: '', recursos: '', profissionais_responsaveis: [], observacoes: '' }
            this.dadosOriginal = {}
            this.alunos = []
            this.modalVisivel = true
        },
        editar (item) {
            const d = item.dados || {}
            this.dadosOriginal = { ...d }
            // preserva a opção do aluno no select
            this.alunos = item.aluno ? [{ id: item.aluno.id, nome: item.aluno.nome }] : []
            this.dados = {
                id: item.id,
                aluno_id: item.aluno_id,
                data_aplicacao: item.data_aplicacao ? this.$moment(item.data_aplicacao).format('YYYY-MM-DD') : '',
                areas: Array.isArray(d.areas) ? d.areas : [],
                justificativa: d.justificativa || '',
                estrategias: d.estrategias || '',
                recursos: d.recursos || '',
                profissionais_responsaveis: Array.isArray(d.profissionais_responsaveis) ? d.profissionais_responsaveis : (d.profissionais_responsaveis ? [d.profissionais_responsaveis] : []),
                observacoes: d.observacoes || ''
            }
            this.modalVisivel = true
        },
        salvar () {
            if (!this.dados.aluno_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione o aluno.', type: 'warning' })
                return
            }
            this.salvando = true
            const payload = {
                aluno_id: this.dados.aluno_id,
                periodo_letivo_id: (this.$store.state.config.periodo && this.$store.state.config.periodo.id) || null,
                data_aplicacao: this.dados.data_aplicacao || null,
                dados: {
                    ...this.dadosOriginal,
                    areas: this.dados.areas || [],
                    justificativa: this.dados.justificativa || '',
                    estrategias: this.dados.estrategias || '',
                    recursos: this.dados.recursos || '',
                    profissionais_responsaveis: this.dados.profissionais_responsaveis || [],
                    observacoes: this.dados.observacoes || ''
                }
            }
            const url = this.dados.id
                ? `${this.baseUrl()}/api/rac-aluno/update/${this.dados.id}`
                : `${this.baseUrl()}/api/rac-aluno/store`
            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                this.salvando = false
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'R.A.C salvo com sucesso.', type: 'success' })
                this.modalVisivel = false
                this.loadingRacs(this.paginate.page)
            }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
        },
        excluir (item) {
            this.$msgbox.confirm('Excluir este R.A.C?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => {
                    this.$axios.delete(`${this.baseUrl()}/api/rac-aluno/delete/${item.id}`, this.$store.getters.getHeaderAuth)
                        .then(() => { window.eventBus.$emit('alert', { msg: 'R.A.C excluído.', type: 'success' }); this.loadingRacs(this.paginate.page) })
                        .catch(e => this.$store.commit('throwException', e))
                }).catch(() => {})
        },
        imprimir (item) {
            this.$axios.get(`${this.baseUrl()}/api/rac-aluno/imprimir/${item.id}`, this.$store.getters.getHeaderAuthExcel)
                .then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                    const url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.target = '_blank'
                    link.click()
                    window.URL.revokeObjectURL(url)
                }).catch(e => this.$store.commit('throwException', e))
        },
        abrirEventos (item) {
            this.racSelecionadoId = item.id
            this.novoEvento = { data: this.$moment().format('YYYY-MM-DD'), descricao: '' }
            this.eventos = []
            this.eventosModalVisivel = true
            this.carregarEventos()
        },
        carregarEventos () {
            if (!this.racSelecionadoId) return
            this.$axios.get(`${this.baseUrl()}/api/rac-aluno/evento/getByRac/${this.racSelecionadoId}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.eventos = Array.isArray(r.data) ? r.data : [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        salvarEvento () {
            if (!this.novoEvento.descricao) return
            this.salvandoEvento = true
            const payload = { rac_aluno_id: this.racSelecionadoId, data: this.novoEvento.data || null, descricao: this.novoEvento.descricao }
            this.$axios.post(`${this.baseUrl()}/api/rac-aluno/evento/store`, payload, this.$store.getters.getHeaderAuth).then(r => {
                this.salvandoEvento = false
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' }); return }
                this.novoEvento = { data: this.$moment().format('YYYY-MM-DD'), descricao: '' }
                this.carregarEventos()
            }).catch(e => { this.salvandoEvento = false; this.$store.commit('throwException', e) })
        },
        excluirEvento (ev) {
            this.$msgbox.confirm('Excluir este evento?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => {
                    this.$axios.delete(`${this.baseUrl()}/api/rac-aluno/evento/delete/${ev.id}`, this.$store.getters.getHeaderAuth)
                        .then(() => this.carregarEventos())
                        .catch(e => this.$store.commit('throwException', e))
                }).catch(() => {})
        },
        formatData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' }
    }
}
</script>
